(function () {
  document.querySelectorAll('complete-the-look.ctl').forEach(function (section) { initSection(section); });

  // Combined-listing anchor colour links swap the whole product region with
  // parsed HTML (scripts don't re-run there), so the block self-initializes
  // whenever it is inserted into the document.
  if (window.customElements && !customElements.get('complete-the-look')) {
    customElements.define('complete-the-look', class extends HTMLElement {
      connectedCallback() {
        var el = this;
        setTimeout(function () { if (el.classList.contains('ctl')) initSection(el); }, 0);
      }
    });
  }

  function initSection(section) {
    if (section.dataset.ctlInitialized === '1') return;
    section.dataset.ctlInitialized = '1';

    var tabs = section.querySelectorAll('[data-ctl-tab]');
    var panels = section.querySelectorAll('[data-ctl-panel]');
    var cards = section.querySelectorAll('[data-ctl-card]');
    var addBtn = section.querySelector('[data-pairing-add]');
    var errorEl = section.querySelector('[data-pairing-error]');
    var ctaTextEl = addBtn ? addBtn.querySelector('.ctl__cta-text') : null;
    var ctaOriginalText = ctaTextEl ? ctaTextEl.textContent.trim() : '';

    var t = {
      selectSizeError: section.dataset.tSelectSizeError || 'Please select a size',
      adding: section.dataset.tAdding || 'Adding...',
      added: section.dataset.tAdded || 'Added!',
      error: section.dataset.tError || 'Something went wrong. Please try again.',
    };

    // ── Variant-aware pairing state ──────────────────────────────────────────
    // The variant map is keyed by ProductOptionValue GIDs (rename-proof);
    // colour names ride along as a fallback.
    function norm(s) { return String(s || '').trim().toLowerCase(); }
    var anchorColorPos = parseInt(section.dataset.anchorColorPos || '0', 10);
    var currentAnchorColor = section.dataset.anchorColor || '';
    var currentAnchorPrice = parseInt(section.dataset.activeProductPrice || '0', 10);
    var variantMapRows = [];
    var anchorColorToGid = {};
    var mapEl = section.querySelector('[data-ctl-variant-map]');
    if (mapEl) {
      try { variantMapRows = JSON.parse(mapEl.textContent) || []; } catch (e) { variantMapRows = []; }
    }
    var anchorColorsEl = section.querySelector('[data-ctl-anchor-colors]');
    if (anchorColorsEl) {
      try {
        (JSON.parse(anchorColorsEl.textContent) || []).forEach(function (val) {
          if (val && val.name) anchorColorToGid[norm(val.name)] = val.id;
        });
      } catch (e) {}
    }

    // ── Anchor (current PDP product) ─────────────────────────────────────────
    function resolveAnchorVariant() {
      var scope = document.querySelector('product-rerender[id^="product-info-"]') || document;
      var idInput = scope.querySelector('form[id^="product-form-main-"] input[name="id"]');
      var id = idInput && idInput.value ? parseInt(idInput.value, 10) : 0;
      if (!id) {
        var seedId = parseInt(section.dataset.activeVariantId || '0', 10);
        return seedId ? { id: seedId } : null;
      }
      return { id: id };
    }

    // ── Helpers ──────────────────────────────────────────────────────────────
    function cardData(card) {
      if (card._ctlData) return card._ctlData;
      var script = card.querySelector('[data-ctl-product]');
      var data = { colorPos: 0, sizePos: 0, discountType: 'percentage', discountValue: 0, variants: [] };
      if (script) { try { data = JSON.parse(script.textContent); } catch (e) {} }
      card._ctlData = data;
      return data;
    }

    function perUnit(data, priceCents) {
      if (!priceCents || priceCents <= 0) return 0;
      if (data.discountType === 'percentage') {
        var pct = Math.min(Math.max(data.discountValue, 0), 100);
        return Math.round(priceCents * pct / 100);
      }
      return Math.min(Math.round(data.discountValue * 100), priceCents);
    }

    function formatMoney(cents) {
      if (window.Shopify && window.Shopify.formatMoney) return window.Shopify.formatMoney(cents);
      return '$' + (cents / 100).toFixed(2);
    }

    function updatePrice(card, priceCents) {
      var data = cardData(card);
      var priceEl = card.querySelector('[data-ctl-price]');
      var compareEl = card.querySelector('[data-ctl-compare]');
      var discounted = priceCents - perUnit(data, priceCents);
      if (priceEl) priceEl.textContent = formatMoney(discounted);
      if (compareEl) compareEl.textContent = formatMoney(priceCents);
    }

    function variantsForColor(data, color) {
      if (data.colorPos <= 0 || !color) return data.variants;
      return data.variants.filter(function (v) { return v.color === color; });
    }

    function firstAvailable(list) {
      return list.find(function (v) { return v.available; }) || list[0] || null;
    }

    function buildSizeOptions(card, color) {
      var data = cardData(card);
      var variants = variantsForColor(data, color);
      var sizeSelect = card.querySelector('[data-ctl-size]');
      if (sizeSelect) {
        sizeSelect.innerHTML = '';
        var ph = document.createElement('option');
        ph.value = ''; ph.disabled = true; ph.selected = true; ph.textContent = 'SELECT SIZE';
        sizeSelect.appendChild(ph);
        variants.forEach(function (v) {
          var opt = document.createElement('option');
          opt.value = String(v.id);
          opt.textContent = v.size + (v.available ? '' : ' - Sold out');
          opt.disabled = !v.available;
          opt.dataset.price = v.price;
          sizeSelect.appendChild(opt);
        });
      }
      var sizeBlocks = card.querySelector('[data-ctl-size-blocks]');
      if (sizeBlocks) {
        sizeBlocks.innerHTML = '';
        var name = sizeBlocks.dataset.name || 'ctl-size';
        variants.forEach(function (v, idx) {
          var wrap = document.createElement('div');
          wrap.className = 'block-swatch' + (v.available ? '' : ' is-disabled');
          var input = document.createElement('input');
          input.className = 'block-swatch__radio visually-hidden';
          input.type = 'radio';
          input.name = name;
          input.id = name + '-js-' + idx;
          input.value = String(v.id);
          input.disabled = !v.available;
          input.dataset.price = v.price;
          input.dataset.color = v.color || '';
          var label = document.createElement('label');
          label.className = 'block-swatch__item';
          label.htmlFor = input.id;
          label.textContent = v.size;
          wrap.appendChild(input);
          wrap.appendChild(label);
          sizeBlocks.appendChild(wrap);
        });
      }
    }

    function setImage(card, src) {
      var imageEl = card.querySelector('[data-ctl-image]');
      if (!imageEl || !src) return;
      imageEl.removeAttribute('srcset');
      imageEl.src = src;
    }

    function setSelected(card, variantId, priceCents) {
      card.dataset.selectedVariant = variantId || '';
      if (variantId) clearSizeError();
      if (variantId && priceCents) updatePrice(card, priceCents);
      if (variantId) {
        // Show the exact variant's image (flatlay metafield when set).
        var data = cardData(card);
        for (var i = 0; i < data.variants.length; i++) {
          if (String(data.variants[i].id) === String(variantId)) {
            setImage(card, data.variants[i].image);
            break;
          }
        }
      }
      updateSavings();
    }

    // Missing-size UX: the CTA's contents animate out, the message animates
    // in on the button itself, and the offending size selector pulses.
    var sizeErrorTimer = null;
    function showSizeError(card) {
      var ctaError = addBtn ? addBtn.querySelector('[data-ctl-cta-error]') : null;
      if (addBtn && ctaError) {
        ctaError.textContent = t.selectSizeError;
        addBtn.classList.add('is-error');
        if (sizeErrorTimer) clearTimeout(sizeErrorTimer);
        sizeErrorTimer = setTimeout(function () { addBtn.classList.remove('is-error'); }, 2600);
      } else if (errorEl) {
        errorEl.textContent = t.selectSizeError;
        errorEl.hidden = false;
      }
      var sizeSelect = card.querySelector('[data-ctl-size]');
      var sizeUi = card.querySelector('[data-ctl-size-blocks]') || (sizeSelect ? sizeSelect.parentElement : null);
      if (sizeUi) {
        sizeUi.classList.remove('ctl__size-attention');
        void sizeUi.offsetWidth;
        sizeUi.classList.add('ctl__size-attention');
        setTimeout(function () { sizeUi.classList.remove('ctl__size-attention'); }, 2600);
      }
      if (sizeSelect) sizeSelect.focus();
    }

    function clearSizeError() {
      if (!addBtn) return;
      addBtn.classList.remove('is-error');
      if (sizeErrorTimer) { clearTimeout(sizeErrorTimer); sizeErrorTimer = null; }
    }

    // "Save $X" badge in the CTA: the selected pair's total savings.
    function updateSavings() {
      var badge = section.querySelector('[data-ctl-savings]');
      if (!badge) return;
      var card = selectedCard();
      var total = 0;
      if (card) {
        var data = cardData(card);
        var price = 0;
        var vid = card.dataset.selectedVariant || '';
        if (vid) {
          for (var i = 0; i < data.variants.length; i++) {
            if (String(data.variants[i].id) === String(vid)) { price = data.variants[i].price; break; }
          }
        }
        if (!price) {
          var rep = firstAvailable(variantsForColor(data, card.dataset.currentColor || data.defaultColor));
          if (rep) price = rep.price;
        }
        total += perUnit(data, price);
        if ((section.dataset.discountTarget || 'both') === 'both') total += perUnit(data, currentAnchorPrice);
      }
      if (total > 0) {
        badge.textContent = 'Save ' + formatMoney(total).replace(/\.00\b/, '').replace(/,00\b/, '');
        badge.hidden = false;
      } else {
        badge.hidden = true;
      }
    }

    function swapImage(card, color) {
      var data = cardData(card);
      var v = firstAvailable(variantsForColor(data, color));
      if (v) setImage(card, v.image);
    }

    function autoSelectSingle(card) {
      var sizeSelect = card.querySelector('[data-ctl-size]');
      if (sizeSelect) {
        var real = [];
        for (var i = 0; i < sizeSelect.options.length; i++) {
          if (sizeSelect.options[i].value) real.push(sizeSelect.options[i]);
        }
        if (real.length === 1 && !real[0].disabled) {
          sizeSelect.value = real[0].value;
          setSelected(card, real[0].value, parseInt(real[0].dataset.price || '0', 10));
        }
        return;
      }
      var sizeBlocks = card.querySelector('[data-ctl-size-blocks]');
      if (sizeBlocks) {
        var radios = sizeBlocks.querySelectorAll('input');
        if (radios.length === 1 && !radios[0].disabled) {
          radios[0].checked = true;
          setSelected(card, radios[0].value, parseInt(radios[0].dataset.price || '0', 10));
        }
      }
    }

    // Combined cards: each colour is a different child product — re-point
    // the image/title links at the selected child's page.
    function updateCardLinks(card, color) {
      var data = cardData(card);
      var values = data.colorValues || [];
      for (var i = 0; i < values.length; i++) {
        if (values[i].url && norm(values[i].name) === norm(color)) {
          var links = card.querySelectorAll('[data-ctl-link]');
          for (var j = 0; j < links.length; j++) links[j].setAttribute('href', values[i].url);
          break;
        }
      }
    }

    function applyColor(card, color) {
      var data = cardData(card);
      buildSizeOptions(card, color);
      swapImage(card, color);
      updateCardLinks(card, color);
      var swWrap = card.querySelector('[data-ctl-color-swatches]');
      if (swWrap) {
        var swRadios = swWrap.querySelectorAll('input');
        for (var s = 0; s < swRadios.length; s++) swRadios[s].checked = norm(swRadios[s].value) === norm(color);
      }
      setSelected(card, '', 0);
      var rep = firstAvailable(variantsForColor(data, color));
      if (rep) updatePrice(card, rep.price);
      autoSelectSingle(card);
      card.dataset.currentColor = color;
    }

    // Which of this card's colours to show for the anchor's colour:
    // mapped valueId → mapped name → auto same-name; null = keep current.
    function resolveCardColor(card, anchorColor) {
      var data = cardData(card);
      if (!data.colorPos || data.colorPos <= 0) return null;
      var anchorGid = anchorColorToGid[norm(anchorColor)] || '';
      var row = null;
      for (var i = 0; i < variantMapRows.length; i++) {
        var ids = variantMapRows[i].anchorValueIds || [];
        if (anchorGid && ids.indexOf(anchorGid) !== -1) { row = variantMapRows[i]; break; }
      }
      if (!row) {
        for (var j = 0; j < variantMapRows.length; j++) {
          if (norm(variantMapRows[j].anchorColor) === norm(anchorColor)) { row = variantMapRows[j]; break; }
        }
      }
      var candidates = [];
      if (row) {
        var match = null;
        (row.matches || []).forEach(function (m) {
          if (!match && m.productId === data.productGid) match = m;
        });
        if (match) {
          if (match.valueId && data.colorValues) {
            for (var k = 0; k < data.colorValues.length; k++) {
              if (data.colorValues[k].id === match.valueId) { candidates.push(data.colorValues[k].name); break; }
            }
          }
          if (match.color) candidates.push(match.color);
        }
      }
      candidates.push(anchorColor);
      for (var c = 0; c < candidates.length; c++) {
        var key = norm(candidates[c]);
        if (!key) continue;
        for (var v = 0; v < data.variants.length; v++) {
          if (norm(data.variants[v].color) === key) return data.variants[v].color;
        }
      }
      return null;
    }

    // ── Per-card wiring ──────────────────────────────────────────────────────
    cards.forEach(function (card) {
      var data = cardData(card);
      var colorSelect = card.querySelector('[data-ctl-color]');
      var sizeSelect = card.querySelector('[data-ctl-size]');
      var selectRadio = card.querySelector('[data-ctl-select]');

      card.dataset.currentColor = data.defaultColor || '';

      if (selectRadio) selectRadio.addEventListener('change', function () { updateSavings(); });

      if (colorSelect) {
        colorSelect.addEventListener('change', function () {
          applyColor(card, this.value);
        });
      }

      var colorSwatches = card.querySelector('[data-ctl-color-swatches]');
      if (colorSwatches) {
        colorSwatches.addEventListener('change', function (e) {
          if (e.target && e.target.value) applyColor(card, e.target.value);
        });
      }

      var sizeBlocksWrap = card.querySelector('[data-ctl-size-blocks]');
      if (sizeBlocksWrap) {
        sizeBlocksWrap.addEventListener('change', function (e) {
          if (e.target && e.target.value) setSelected(card, e.target.value, parseInt(e.target.dataset.price || '0', 10));
        });
      }

      if (sizeSelect) {
        sizeSelect.addEventListener('change', function () {
          var opt = this.options[this.selectedIndex];
          if (!this.value) { setSelected(card, '', 0); return; }
          setSelected(card, this.value, opt ? parseInt(opt.dataset.price || '0', 10) : 0);
        });
      }

      // Init: single-variant products get auto-selected; otherwise wait for a size pick.
      autoSelectSingle(card);
    });
    updateSavings();

    // ── Tabs ─────────────────────────────────────────────────────────────────
    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        var groupId = tab.dataset.groupId;
        tabs.forEach(function (tb) {
          var on = tb.dataset.groupId === groupId;
          tb.classList.toggle('is-active', on);
          tb.setAttribute('aria-selected', on ? 'true' : 'false');
        });
        panels.forEach(function (panel) { panel.hidden = panel.dataset.groupId !== groupId; });
        updateSavings();
      });
    });

    // ── Follow the anchor's colour ───────────────────────────────────────────
    // In-product variant changes fire `variant:change` on the PDP form (bubbles
    // to document) and do NOT re-render this block, so the cards are re-pointed
    // here. Anchor size-only changes are ignored to preserve card state.
    document.addEventListener('variant:change', function (e) {
      var detail = e.detail || {};
      // The event is dispatched on the form and bubbles. detail.formId (and
      // e.target.id) is the form's <input name="id"> element — the named
      // control shadows the id property — so read the attribute instead.
      var formId = e.target && e.target.getAttribute ? e.target.getAttribute('id') || '' : '';
      if (formId.indexOf('product-form-main-') !== 0) return;
      var variant = detail.variant;
      if (!variant) return;
      if (variant.price) { currentAnchorPrice = variant.price; updateSavings(); }
      if (anchorColorPos <= 0 || !variant.options) return;
      var newColor = variant.options[anchorColorPos - 1];
      if (!newColor || norm(newColor) === norm(currentAnchorColor)) return;
      currentAnchorColor = newColor;
      section.dataset.anchorColor = newColor;
      cards.forEach(function (card) {
        var target = resolveCardColor(card, newColor);
        if (!target || norm(target) === norm(card.dataset.currentColor || '')) return;
        var colorSelect = card.querySelector('[data-ctl-color]');
        if (colorSelect) colorSelect.value = target;
        applyColor(card, target);
      });
    });

    function activePanel() {
      for (var i = 0; i < panels.length; i++) { if (!panels[i].hidden) return panels[i]; }
      return panels[0] || null;
    }
    function selectedCard() {
      var panel = activePanel();
      if (!panel) return null;
      var checked = panel.querySelector('[data-ctl-select]:checked');
      if (checked) {
        var wrap = checked.closest('[data-ctl-card]');
        if (wrap) return wrap;
      }
      return panel.querySelector('[data-ctl-card]');
    }

    // ── Add to cart ──────────────────────────────────────────────────────────
    if (addBtn) {
      addBtn.addEventListener('click', function () {
        if (errorEl) errorEl.hidden = true;

        var card = selectedCard();
        if (!card) return;

        var sizeSelect = card.querySelector('[data-ctl-size]');
        var variantId = card.dataset.selectedVariant;
        if (sizeSelect && sizeSelect.value) variantId = sizeSelect.value;
        if (!variantId || variantId === '') {
          showSizeError(card);
          return;
        }

        var matchId = parseInt(variantId, 10);
        var anchor = resolveAnchorVariant();
        var pairingKey = section.dataset.pairingKey || 'pairing';

        addBtn.disabled = true;
        if (ctaTextEl) ctaTextEl.textContent = t.adding;

        // Every add is a complete pair: the anchor is added each time (two
        // pairs = two anchor units). The anchor line carries no _pairing_id so
        // its lines merge into one cart row with an aggregated quantity.
        var pairIds = anchor && anchor.id ? [anchor.id, matchId] : [matchId];
        var sortedIds = pairIds.slice().sort(function (a, b) { return a - b; });
        var pairingId = pairingKey + '-' + sortedIds.join('-');
        var items = [];
        if (anchor && anchor.id) items.push({ id: anchor.id, quantity: 1, properties: {} });
        items.push({ id: matchId, quantity: 1, properties: { _pairing_id: pairingId } });

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: items }),
        })
          .then(function (res) {
            if (!res.ok) throw new Error(t.error);
            return res.json();
          })
          .then(function () {
            if (ctaTextEl) ctaTextEl.textContent = t.added;
            fetch('/cart.js')
              .then(function (r) { return r.json(); })
              .then(function (cartContent) {
                document.documentElement.dispatchEvent(
                  new CustomEvent('cart:refresh', { bubbles: true, detail: { cart: cartContent, openMiniCart: true } })
                );
              })
              .catch(function () {
                document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
              });
            setTimeout(function () {
              addBtn.disabled = false;
              if (ctaTextEl) ctaTextEl.textContent = ctaOriginalText;
            }, 2000);
          })
          .catch(function (err) {
            if (errorEl) { errorEl.textContent = (err && err.message) || t.error; errorEl.hidden = false; }
            addBtn.disabled = false;
            if (ctaTextEl) ctaTextEl.textContent = ctaOriginalText;
          });
      });
    }
  }
})();
